import * as Address from '@/services/rest-api/lib/delivery/address'
// Archieved for Refinement
// import IMask from 'imask'

// const maskOptions = {
//   mask: '00 H\\ari 0 J\\am 0 Menit',
//   blocks: {
//     '00': {
//       mask: IMask.MaskedRange,
//       from: 0,
//       to: 31,
//     },
//     0: {
//       mask: IMask.MaskedRange,
//       from: 0,
//       to: 23,
//     },
//   },
// }

const translate = (t, key, fallback, params = {}) => {
  if (typeof t !== 'function') return fallback

  const translated = t(key, params)

  return translated === key ? fallback : translated
}

const getWeekdaysMin = (locale) =>
  locale === 'en' ? ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'] : ['Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab', 'Min']

const getAddressTableFields = (t) => [
  {
    label: translate(t, 'master.form.address.name', 'Nama Lokasi'),
    key: 'name',
    isSortable: true,
    isRedirectable: true,
  },
  {
    label: translate(t, 'master.form.address.category', 'Kategori Alamat'),
    key: 'category',
    isSortable: true,
    isRedirectable: true,
  },
  {
    label: translate(t, 'master.form.address.fullAddress', 'Alamat Lengkap'),
    key: 'full_name',
    isSortable: true,
    isRedirectable: true,
  },
  {
    label: translate(t, 'master.form.address.province', 'Provinsi'),
    key: 'province',
    isSortable: true,
    isRedirectable: true,
  },
  {
    label: translate(t, 'master.form.address.city', 'Kota'),
    key: 'city',
    isSortable: true,
    isRedirectable: true,
  },
]

const getDateLang = (locale) => ({
  formatLocale: {
    weekdaysMin: getWeekdaysMin(locale),
  },
})

const getDraftFields = (t, locale) => [
  {
    name: 'destination_address_id',
    showKey: 'destination_address',
    type: 'value-help',
    label: translate(t, 'delivery.fields.destinationAddress', 'Alamat Tujuan'),
    placeholder: translate(t, 'delivery.placeholder.destinationAddress', 'Pilih Alamat Tujuan'),
    validation: 'required',
    trackBy: 'id',
    getInitialObject: (obj) => obj?.destination_address_id,
    displayedBy: 'name',
    listGetter: Address.get(),
    tableFields: getAddressTableFields(t),
    gridColSpan: 2,
  },
  {
    key: 'expected_delivered_on',
    name: 'expected_delivered_on',
    label: translate(t, 'delivery.fields.estimatedDelivered', 'Target Terkirim'),
    placeholder: translate(t, 'global.action.selectDate', 'Pilih Tanggal'),
    type: 'date-picker',
    datepickerType: 'datetime',
    valueType: 'YYYY-MM-DDTHH:mm:ss.SSSZ',
    validation: 'bail|optional|timeGteNow|timeGteField:expected_pickup_on',
    validationMessages: {
      timeGteNow: translate(
        t,
        'delivery.validation.estimatedDeliveredAfterToday',
        'Target Terkirim tidak boleh kurang dari hari Ini'
      ),
      timeGteField: translate(
        t,
        'delivery.validation.estimatedDeliveredAfterPickup',
        'Target Terkirim tidak boleh kurang dari Target Diambil'
      ),
    },
    format: 'DD MMM YYYY HH:mm',
    showSecond: false,
    confirm: true,
    confirmText: translate(t, 'global.action.apply', 'Terapkan'),
    lang: getDateLang(locale),
  },
]

const getConfirmedFields = (t, locale) => [
  {
    name: 'destination_address_id',
    showKey: 'destination_address',
    type: 'value-help',
    label: translate(t, 'delivery.fields.destinationAddress', 'Alamat Tujuan'),
    placeholder: translate(t, 'delivery.placeholder.destinationAddress', 'Pilih Alamat Tujuan'),
    getInitialObject: (obj) => obj?.destination_address_id,
    displayedBy: 'name',
    disabled: true,
    gridColSpan: 2,
  },
  {
    key: 'expected_delivered_on',
    name: 'expected_delivered_on',
    label: translate(t, 'delivery.fields.estimatedDelivered', 'Target Terkirim'),
    placeholder: translate(t, 'global.action.selectDate', 'Pilih Tanggal'),
    type: 'date-picker',
    validation: 'bail|optional|timeGteNow|timeGteField:expected_pickup_on',
    validationMessages: {
      timeGteNow: translate(
        t,
        'delivery.validation.estimatedDeliveredAfterToday',
        'Target Terkirim tidak boleh kurang dari hari Ini'
      ),
      timeGteField: translate(
        t,
        'delivery.validation.estimatedDeliveredAfterPickup',
        'Target Terkirim tidak boleh kurang dari Estimasi Pengambilan'
      ),
    },
    datepickerType: 'datetime',
    valueType: 'YYYY-MM-DDTHH:mm:ss.SSSZ',
    format: 'DD MMM YYYY HH:mm',
    showSecond: false,
    confirm: true,
    confirmText: translate(t, 'global.action.apply', 'Terapkan'),
    lang: getDateLang(locale),
  },
]

const getScheduledFields = (t, locale) => [
  {
    name: 'destination_address_id',
    showKey: 'destination_address',
    type: 'value-help',
    label: translate(t, 'delivery.fields.destinationAddress', 'Alamat Tujuan'),
    placeholder: translate(t, 'delivery.placeholder.destinationAddress', 'Pilih Alamat Tujuan'),
    getInitialObject: (obj) => obj?.destination_address_id,
    displayedBy: 'name',
    disabled: true,
    gridColSpan: 2,
  },
  {
    key: 'expected_delivered_on',
    name: 'expected_delivered_on',
    label: translate(t, 'delivery.fields.estimatedDelivered', 'Target Terkirim'),
    placeholder: translate(
      t,
      'delivery.placeholder.estimatedDeliveredUndefined',
      'Tanggal tidak ditentukan'
    ),
    type: 'date-picker',
    datepickerType: 'datetime',
    valueType: 'YYYY-MM-DDTHH:mm:ss.SSSZ',
    format: 'DD MMM YYYY HH:mm',
    lang: getDateLang(locale),
    disabled: true,
  },
]

const getDestinationAddressFields = (t, locale) => ({
  Draf: getDraftFields(t, locale),
  Dikonfirmasi: getConfirmedFields(t, locale),
  'Menunggu Vendor': getConfirmedFields(t, locale),
  Ditolak: getConfirmedFields(t, locale),
  'Diterima Vendor': getConfirmedFields(t, locale),
  Dijadwalkan: getScheduledFields(t, locale),
  'Dijadwalkan Ulang': getConfirmedFields(t, locale),
  Dijalankan: getScheduledFields(t, locale),
  Diambil: getScheduledFields(t, locale),
  Terkirim: getScheduledFields(t, locale),
  Dibatalkan: getScheduledFields(t, locale),
  'Sedang Transit': getScheduledFields(t, locale),

  default: getDraftFields(t, locale),
})

export default getDestinationAddressFields
